import classNames from "classnames";
import "./Headings.scss";

export function PhoneSubBox({
  children,
  htmlId,
  className,
}: {
  children: React.ReactNode;
  htmlId?: string;
  className?: string;
}) {
  const phoneSubBoxClassName = classNames(
    "box-heading phone-sub-box",
    className
  );
  return (
    <div className={phoneSubBoxClassName} id={htmlId}>
      {children}
    </div>
  );
}
